import axios from "axios";
import { sisikong_url } from "..";

type AppUserDef = {
  id: number;
  username: string;
  first_name: string;
  last_name: string;
  email: string;
  status: "active" | "inactive";
  tags: string[];
  created: string;
  edited: string;
  last_login: string | null;
  user_type: "company" | "sales_partner";
  entity_name: string;
  entity_type: "member" | "subagent";
  entity_id: number;
};

export function getAppUser(user_id: string, token: string): Promise<{ data: AppUserDef }> {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  return axios.get(`${sisikong_url}/crm/external/app-user-details/${user_id}`, { headers });
}
